import React from "react";
import { StyleSheet, View } from "react-native";
import { ThemedValues } from 'styles/themed'

const PlaceholderContainer = ({ style = {}, children }) => {

	return (
		<View style={ [ styles.container, style ] }>
			{ children }
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		padding: ThemedValues.marginHorizontal
	}
});

export default PlaceholderContainer
